import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const ProgramRate = {
  state: () => ({
    items: [],
    participants: [],
    programs: [],
    timeout: null,
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
      status: null,
      speakerID: null,
      programID: null,
      participantNO: null,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setProgramRate(state, payload) {
      state.items = payload.items;
      state.participants = payload.participants;
      state.programs = payload.programs;

      state.filter.total = payload.total;
    },
    setSelectedProgramRate(state, payload) {
      state.selectedItems = payload;
    },
    setProgramRatePage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getProgramRate");
    },
    setProgramRateTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getProgramRate");
    },
  },
  actions: {
    async getProgramRate(store) {
      store.state.loading = true;
      clearTimeout(store.state.timeout);
      store.state.timeout = null;
      store.state.timeout = setTimeout(async () => {
        await axios
          .post("programrate/load", {
            ...store.state.filter,
            skip: (store.state.filter.page - 1) * store.state.filter.take,
          })
          .then((res) => {
            store.state.loading = false;
            return store.commit("setProgramRate", res.data.data);
          });
      }, 25);
    },
    // async toggleSpeaker(store, payload) {
    //   var res = await axios.post("speaker/toggleisactive", {
    //     id: store.state.items[payload.index].id,
    //   });
    //   return res.data;
    // },
    async deleteProgramRate(store, payload) {
      await axios
        .post("programrate/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setProgramRatePage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
    async confirmProgramRate(store, payload) {
      await axios
        .post("programrate/ChangeRateStatus", {
          id: store.state.items[payload.index].id,
          status: 1,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            payload.context.$message.success(res.data.alert.message);
            store.state.items.splice(payload.index, 1, {
              ...store.state.items[payload.index],
              status: 1,
            });
          }
        });
    },
    async cancelProgramRate(store, payload) {
      await axios
        .post("programrate/ChangeRateStatus", {
          id: store.state.items[payload.index].id,
          status: 2,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            payload.context.$message.success(res.data.alert.message);
            store.state.items.splice(payload.index, 1, {
              ...store.state.items[payload.index],
              status: 2,
            });
          }
        });
    },
  },
  getters: {},
};
export default ProgramRate;



// WEBPACK FOOTER //
// ./src/store/programrate.js